import { useAuth } from './useAuth';
import { isAdmin, isAdminEmail } from '@/lib/admin';

export interface UseIsAdminResult {
  isAdmin: boolean;
  isAdminEmail: boolean;
  needsEmailVerification: boolean;
  loading: boolean;
}

export function useIsAdmin(): UseIsAdminResult {
  const { user, loading } = useAuth();
  const admin = isAdmin(user);
  const emailMatch = isAdminEmail(user);
  return {
    isAdmin: admin,
    isAdminEmail: emailMatch,
    needsEmailVerification: emailMatch && !admin,
    loading,
  };
}
